import { render, staticRenderFns } from "./PublishingContractsCostsEditPanelDialog.vue?vue&type=template&id=79aded70"
import script from "./PublishingContractsCostsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./PublishingContractsCostsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports